export const bloodGroupArray = ["A +ve","A -ve","B +ve","B -ve","O +ve","O -ve","AB +ve",   "AB -ve"]